<template>
  <div id="app">
    <div v-if="!isPhone()" class="windows">
      <menuVue />
      <el-row>
        <el-col :span="24">
          <headVue />
          <el-scrollbar class="view" style="height: calc( 100vh - 86px);margin-left: 210px;">
            <router-view />
            <div class="footer">
              <p>Copyright © 2016-{{ new Date().getFullYear() }} | <a href="http://www.mintfirst.com/">明特（上海）国际物流有限公司</a>
                | All Rights Reserve |<a href="https://beian.miit.gov.cn/">
                  沪ICP备14028382号</a></p>
            </div>
          </el-scrollbar>
        </el-col>
      </el-row>
    </div>

    <div v-else class="phone">
      <phoneVue />
    </div>
  
  </div>
</template>
<script>
import menuVue from '@/components/menuComponent.vue'
import headVue from '@/components/head.vue'
import phoneVue from '@/views/phone/phone.vue'
import ElScrollbar from 'element-ui/lib/scrollbar';
import Register from '@/views/register/index.vue';
export default {
  name: 'app',
  components: {
    menuVue,
    ElScrollbar,
    headVue,
    phoneVue,
    Register
  },
  data: () => {
    return {
    
    }
  },
  methods: {
    isPhone() {
      return navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
    },
  },
  mounted() {

  },
}
</script>
<style>
* {
  margin: 0;
  padding: 0;
}

*:focus {
  outline: none;
}

a {
  text-decoration: none;
}

ul {
  list-style: none;
}

#app {
  background-color: #f4f7ff;
  /* min-width: 1300px; */

}

.windows {
  min-width: 1300px;
}

.phone {
  /* padding: 15px 20px; */
  background-color: white;
}

::v-deep .el-message-box__wrapper {
  left: 210px;
}
</style>
<style scoped>


.view.el-scrollbar ::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;

}

::v-deep .el-col-2 {
  width: 210px;
}

.footer {
  margin: 50px;
  font-size: 12px;
  color: #6f6f6f;
  text-align: center;
}

.footer a {
  color: #6f6f6f;
  text-decoration: none;
}

.footer a:hover {
  color: #ce8900;
  text-decoration: underline;
}
</style>
